import React, { Fragment, useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';
import LanguagePickerList from './LanguagePickerList';

const LanguagePickerPopUp = () => {
    const channels = useSelector((state) => state.channels);
    const [popupIsOpen, setPopupIsOpen] = useState(false);
    const [toggleB2CIsOpen, setToggleB2CIsOpen] = useState(true);
    const [toggleB2BIsOpen, setToggleB2BIsOpen] = useState(false);
    const [languageIsOpen, setLanguageIsOpen] = useState(false);
    const switchUrlB2C = channels.channelIsB2B
        ? channels.switchChannelTypeUrl
        : channels.currentChannelUrl;
    const switchUrlB2B = !channels.channelIsB2B
        ? channels.switchChannelTypeUrl
        : channels.currentChannelUrl;

    const closePopup = () => {
        updateCookies();
        setPopupIsOpen(false);
    };

    const updateCookies = () => {
        var now = new Date();
        now.setTime(now.getTime() + 3600 * 1000 * 24 * 7);
        var cookieExpires = now.toUTCString();
        document.cookie =
            'show_language_picker_popup=' +
            '' +
            ';expires=' +
            cookieExpires +
            ';path=/' +
            ';domain=.' +
            channels.currentDomainName;
    };

    const handleChangeLanguage = () => {
        setLanguageIsOpen(true);
    };

    useEffect(() => {
        let parsedUrl = new URL(location.href);
        let utmSource = parsedUrl.searchParams.get('utm_source');
        if (utmSource !== null && utmSource !== undefined) {
            updateCookies();
            return;
        }
        const isPopupOpen = !document.cookie.includes('show_language_picker_popup');
        setPopupIsOpen(isPopupOpen);
    }, []);

    return (
        <Fragment>
            {popupIsOpen && (
                <div className="language-picker">
                    <div className="language-picker__box">
                        <span className="close-popup-button" onClick={() => closePopup()}>
                            x
                        </span>
                        <div className="language-picker__header">
                            <h1>{translate(`common.languagepicker.headertext`)}</h1>
                        </div>
                        {languageIsOpen ? (
                            <div className="language-picker__table-wrapper">
                                <div className="language-picker__table">
                                    <div
                                        className={`language-picker__table-header ${toggleB2CIsOpen
                                                ? 'language-picker__table-header--active'
                                                : ''
                                            }`}
                                        onClick={() => setToggleB2CIsOpen(!toggleB2CIsOpen)}
                                    >
                                        <h3>{translate(`common.languagepicker.b2cbuttontext`)}</h3>
                                        <i className="language-picker__table-header-icon"></i>
                                    </div>
                                    {toggleB2CIsOpen ? (
                                        <LanguagePickerList
                                            channels={channels.channelsB2C}
                                            showSelected={!channels.channelIsB2B}
                                        />
                                    ) : (
                                        <Fragment></Fragment>
                                    )}
                                </div>
                                <div className="language-picker__table">
                                    <div
                                        className={`language-picker__table-header ${toggleB2BIsOpen
                                                ? 'language-picker__table-header--active'
                                                : ''
                                            }`}
                                        onClick={() => setToggleB2BIsOpen(!toggleB2BIsOpen)}
                                    >
                                        <h3>{translate(`common.languagepicker.b2bbuttontext`)}</h3>
                                        <i className="language-picker__table-header-icon"></i>
                                    </div>
                                    {toggleB2BIsOpen ? (
                                        <LanguagePickerList
                                            channels={channels.channelsB2B}
                                            showSelected={channels.channelIsB2B}
                                        />
                                    ) : (
                                        <Fragment></Fragment>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="language-picker__buttons">
                                    <a
                                        onClick={() => closePopup('B2C')}
                                        className="language-picker__button button btn"
                                        href={switchUrlB2C}
                                    >
                                        {translate(`common.languagepicker.b2cbuttontext`)}
                                    </a>
                                    <a
                                        onClick={() => closePopup('B2B')}
                                        className="language-picker__button button btn"
                                        href={switchUrlB2B}
                                    >
                                        {translate(`common.languagepicker.b2bbuttontext`)}
                                    </a>
                                </div>
                                <div className="language-picker__change-language">
                                    {translate(`common.languagepicker.changelanguagetext`)}{' '}
                                    <a href="#" onClick={() => handleChangeLanguage()}>
                                        <span>
                                            {translate(
                                                `common.languagepicker.changelanguagelinktext`
                                            )}
                                        </span>
                                    </a>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default LanguagePickerPopUp;
